import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

// GET /cost-component
export async function getCostComponents(queryParams = "") {
  return await instance({ baseURL }).get("/cost-component" + queryParams);
}

// GET /cost-component/:id
export async function getCostComponentById(id) {
  return await instance({ baseURL }).get(`/cost-component/${id}`);
}

// POST /cost-component/create
export async function createCostComponent(body) {
  return await instance({ baseURL }).post("/cost-component/create", body);
}

// PATCH /cost-component/update/:id
export async function updateCostComponent(id, body) {
  return await instance({ baseURL }).patch(`/cost-component/update/${id}`, body);
}

// DELETE /cost-component/delete/:id
export async function deleteCostComponent(id) {
  return await instance({ baseURL }).delete(`/cost-component/delete/${id}`);
}
